import React, { Dispatch, useEffect, useState } from 'react'
import {
    List,
    ListItem,
    Dialog,
    DialogTitle,
    ListItemAvatar,
    Avatar,
    ListItemText,
    Typography,
    DialogContentText,
    DialogContent
} from '@material-ui/core'
import { createCodatCompany, createConnection } from '../../../services/codat-service'
import { makeStyles } from '@material-ui/core/styles'
import { decorateCodatURL } from '../../../utils/codat-utils'
import { useCurrentStepperIndex } from '../../../stores/ui/ui.hooks'
import { useEntityState } from '../../../stores/entity/entity.hooks'
import { useDispatch, useSelector } from 'react-redux'
import { setSnackBar } from '../../../stores/ui/ui-action'
import CONSTANTS from '../../../utils/constants'

const useStyles = makeStyles((theme) => ({
    accountHeader: {
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: 500,
        fontSize: theme.spacing(2.5),
        lineHeight: theme.spacing(3.5)
    },
    subHeaderText: {
        fontSize: 'smaller'
    },
    supportEmail: {
        color: 'var(--primary-light)'
    },
    link: {
        '&:hover': {
            textDecoration: 'underline',
            textDecorationThickness: '2px'
        }
    }
}))

interface IAccountLookupModal {
    company?: string
    fieldName?: string
    journeyId?: string
    taskId?: string
    journeyName?: string
    taskName?: string
    connectRoute?: string
    adfId?: string
    onChange?: () => void
    onCloseModal: () => void
}

const AccountLookupModal: React.FC<IAccountLookupModal> = ({
    company,
    onCloseModal,
    onChange,
    journeyId,
    taskId,
    journeyName,
    taskName,
    connectRoute,
    adfId
}) => {
    const classes = useStyles()
    const [clicked, setClicked] = useState('')
    const currentStep = useCurrentStepperIndex()
    const protocol = window.location.protocol
    const host = window.location.host
    const [checkIntegration, setCheckIntegration] = useState(true)
    const { codatIntegration, entityDraft } = useEntityState()
    const dispatch: Dispatch<any> = useDispatch()
    const companyName = company || entityDraft.properties?.legalEntityName.value

    const linkUrlDecorations = {
        protocol: protocol,
        host: host,
        journeyId: journeyId,
        taskId: taskId,
        journeyName: journeyName,
        taskName: taskName,
        step: currentStep,
        connectRoute
    }

    const onClickListItem = async (platformKey) => {
        try {
            setClicked(platformKey)
            const response = await createCodatCompany(companyName, adfId, journeyId)
            const companyId = response.id
            let dataReturned = null
            if (companyId) {
                dataReturned = await createConnection(companyId, platformKey, dispatch)
            }
            if (dataReturned) {
                onChange()
                window.location.href = dataReturned && decorateCodatURL(dataReturned.linkUrl, linkUrlDecorations)
            }
        } catch (e) {
            dispatch(setSnackBar({ show: true, message: 'Problem creating connection with Accounting Software.', messageType: 'error' }))
        }
        onCloseModal()
    }

    return (
        <Dialog
            open={checkIntegration}
            onClose={onCloseModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            maxWidth="sm"
            hideBackdrop={true}
        >
            <DialogTitle className={classes.accountHeader}>Select your accounting software</DialogTitle>
            <List>
                {codatIntegration.map((item) => (
                    <ListItem button key={item.key} onClick={(e) => onClickListItem(item.key)}>
                        <ListItemAvatar>
                            <Avatar src={item.logoUrl} />
                        </ListItemAvatar>
                        <ListItemText>{clicked === item.key ? 'Tranferring you to ' + item.name : item.name}</ListItemText>
                    </ListItem>
                ))}
            </List>
            <DialogContent>
                <DialogContentText>
                    <Typography variant="subtitle2" style={{ fontWeight: 'bold' }}>
                        Don't see your accounting software?
                    </Typography>
                    <Typography variant="body1" className={classes.subHeaderText}>
                        We currently only support the above - more will be added over time. Please reach out to{' '}
                        <span className={classes.supportEmail}>
                            <a href={`mailto:${CONSTANTS.LENDX_SUPPORT_EMAIL}`} className={classes.link}>
                                LendX Support
                            </a>
                        </span>{' '}
                        if you have any questions.
                    </Typography>
                </DialogContentText>
            </DialogContent>
        </Dialog>
    )
}

export default AccountLookupModal
